export const ACCOUNT_TYPE = {
  CMP_ACCOUNT: 'CMP',
  PLS_ACCOUNT: 'PLS',
  LIMITED_ACCOUNT: 'NONE'
};

export const PLS_REWARD_TIERS = {
  PLAY: 'play',
  ESCAPE: 'escape',
  DELIGHT: 'delight',
  FANTASY: 'fantasy'
};

export const filterTier = tier => (tier === 'Unknown' ? '' : tier);

// case insensitive check for "not" and "found" with
// an optional space between them
export const filterField = field => (/^not ?found$/i.test(field) ? '' : field);

// User Profile Fields
export const DISPLAY_NAME = 'displayName';
export const ONLINE_EMAIL = 'onlineEmail';

export const formatAddressFromPlsStatus = addresses => {
  const firstAddress = addresses[0];
  return {
    addressLine1: filterField(firstAddress.street[0]),
    addressLine2:
      firstAddress.street.length > 1 ? firstAddress.street[1] : null,
    city: filterField(firstAddress.city),
    state: filterField(firstAddress.state),
    zip: filterField(firstAddress.postalCode)
  };
};

export const formatPhoneNumbersFromPlsStatus = phones => {
  let mobilePhone;
  let homePhone;

  phones.forEach(phone => {
    if (phone.phoneType === 'mobile') {
      mobilePhone = filterField(phone.phoneNumber);
    } else if (phone.phoneType === 'home') {
      homePhone = filterField(phone.phoneNumber);
    }
  });

  return { mobilePhone, homePhone };
};
